import {Injectable} from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor, HttpResponse
} from '@angular/common/http';
import {Observable, tap} from 'rxjs';
import {Router} from "@angular/router";

@Injectable()
export class HttpInterceptorInterceptor implements HttpInterceptor {

    constructor(public router: Router) {
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        // return next.handle(request);

        return next.handle(request).pipe(
            tap({
              next: (event: any) => {
                if (event instanceof HttpResponse) {

                  if (this.router.url === '/login' || this.router.url === 'login') return event;

                  if(this.isInvalidSessionResponse(event.body)) {
                    // Il middleware di autenticazione ha rifiutato il token Wisper.
                     this.router.navigate(['/login'])
                  }
                }
                return event;
              },
              /*error: (error) => {
                if(error.status === 401) {
                  alert('Unauthorized access!')
                }
                else if(error.status === 404) {
                  alert('Page Not Found!')
                }
              }*/
            }));
    }

    /**
     * Il backend storico restituisce gli errori di autenticazione con HTTP 200 e
     * `status: 401` nel body. Non basta quindi controllare il solo status: anche
     * gli errori dei provider esterni (per esempio Poynt) possono contenerlo e
     * non devono invalidare la sessione Wisper.
     */
    private isInvalidSessionResponse(body: any): boolean {
        return body?.status === 401 &&
            (body?.message === 'invalid_token' || body?.message === 'no_token_provided');
    }
}
